import styled from 'styled-components';

export const StyledModularAddOnsModal = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 840px;
`;

export const StyledModularAddOnsHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    background: linear-gradient(to right, ${(p) => p.theme.colors.loopEmerald}, #009577);
    padding: 20px 20px 24px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
`;

export const StyledModularAddOnFamilyIcon = styled.img`
    width: 64px;
    height: 64px;
    aspect-ratio: 1;
`;

export const StyledModularAddOnsBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 20px;
`;

export const StyledModularAddOnsCloseModal = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 600px;
`;

export const StyledModularAddOnsCloseModalBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    padding: 24px;
    text-align: center;
`;

export const StyledModularAddOnsCompletionsModalBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    padding: 12px 24px 24px;
    text-align: center;
    box-sizing: border-box;
`;

export const StyledModularAddOnsCompletionModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    border-radius: 12px;
    border: 1.5px solid ${({ theme }) => theme.colors.platinum};
    padding: 16px;
    text-align: start;
    width: 100%;
    box-sizing: border-box;
`;

export const StyledModularAddOnsCloseModalFooter = styled.div`
    display: flex;
    gap: 24px;
    align-items: center;
    padding: 16px 32px;
    border-top: 0.5px solid ${({ theme }) => theme.colors.seafoamGray};
`;

export const StyledModularAddOnsCompletionModalText = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    text-align: center;
    align-items: center;
`;

export const StyledModularAddOnsCompletionModalFam = styled.div`
    display: flex;
    gap: 8px;
    border-radius: 5px;
    padding: 12px;
    background-color: ${({ theme }) => theme.colors.surface0};
    align-items: center;
    width: 100%;
    box-sizing: border-box;
`;

export const StyledModularAddOnsCompletionModalFamNew = styled.div`
    display: flex;
    justify-content: space-between;
    border-radius: 5px;
    padding: 12px;
    background: linear-gradient(to right, #c9eacf, ${(p) => p.theme.colors.background});
    align-items: center;
`;

export const StyledModularAddOnsCompletionModalFamNewText = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const StyledModularAddOnsCompletionModalFamNewUpgrade = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const StyledModularAddOnBanner = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 10px;
    padding: 12px 13px;
    background: linear-gradient(to right, ${(p) => p.theme.colors.loopEmerald} 50%, #009577);
    margin-top: 12px;
`;

export const StyledModularAddOnBannerText = styled.div`
    display: flex;
    align-items: center;
    gap: 7px;
    flex: 1;
`;

export const StyledModularDot = styled.div`
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: ${(p) => p.theme.colors.seafoamGray};
`;

export const StyledModularAddOnsDeletionsModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    border-radius: 12px;
    border: 1.5px solid ${({ theme }) => theme.colors.platinum};
    padding: 16px;
    text-align: start;
    width: 100%;
    box-sizing: border-box;
`;

export const StyledModularDeletableMember = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
`;

export const StyledModularDeletableMemberText = styled.div`
    display: flex;
    flex-direction: column;
`;
